import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import {
  httpLoaderFactory,
  msalGuardConfig,
  msalInstanceFactory,
  msalInterceptorConfig,
  translationFactory,
} from '@core-factories';
import {
  apimInterceptor,
  authInterceptor,
  httpErrorInterceptor,
  httpLoaderInterceptor,
} from '@core-interceptors';
import { TranslationService } from '@core-services';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        httpLoaderInterceptor,
        httpErrorInterceptor,
        authInterceptor,
        apimInterceptor,
      ]),
    ),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      deps: [TranslationService],
      useFactory: translationFactory,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: msalGuardConfig,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfig,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true,
      },
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MsalInterceptor,
  ],
};
